/**
 * Контекст MatrixClient.
 *
 * ЗАЧЕМ ПОЯВИЛСЯ (2026-09-13, правка аватаров): аватар теперь качается с
 * авторизацией, то есть каждому месту, где рисуется кружок, нужен client.
 * Таких мест много и они глубоко: строка чата, иконка пространства, автор
 * сообщения в ленте, панель участников. Протаскивать client пропсами через
 * RoomList -> Row -> Avatar означало бы менять сигнатуры половины дерева
 * ради одного значения, которое и так одно на всё приложение.
 *
 * Контекст здесь — не «архитектурная красота», а меньшее из двух зол:
 * client создаётся один раз в App и не меняется до перелогина.
 */
import { createContext, useContext } from "react";
import { tr } from "../i18n";
import type { MatrixClient } from "matrix-js-sdk";

const MatrixClientContext = createContext<MatrixClient | null>(null);

export const MatrixClientProvider = MatrixClientContext.Provider;

/**
 * Клиент из контекста. Бросает, если провайдер забыли: молчаливый null
 * привёл бы к «аватары опять не грузятся» без единой подсказки почему.
 */
export function useMatrixClient(): MatrixClient {
  const client = useContext(MatrixClientContext);
  if (!client) throw new Error(tr("error.providerMissing"));
  return client;
}
